module.exports = __webpack_public_path__ + "ba10bca99f2c077b41e67bcbba1e7b58.svg";